import { useQuery } from "@apollo/client";
import { DEPARTMENT_DROPDOWNS } from "../../Queries";

export default (props) => {
  const { data, refetch, loading, error } = useQuery(DEPARTMENT_DROPDOWNS, {
    ...props,
  });
  return { data: data?.departmentDropdowns, loading, refetch, error };
};
